import classNames from 'classnames';
import Logo from 'shared/components/Logo';

export default function Footer({color}: {color?: string}) {
  return (
    <footer role="contentinfo">
      <div
        className={classNames(
          'flex',
          'justify-center',
          'items-center',
          'py-6',
          'px-4',
          'md:px-8',
        )}
      >
        <a href="/" className={classNames('flex', 'flex-row')}>
          <Logo height={16} color={color} />
        </a>
      </div>
    </footer>
  );
}
